import { render, staticRenderFns } from "./DiscountBookings.vue?vue&type=template&id=065a5589&"
import script from "./DiscountBookings.vue?vue&type=script&lang=js&"
export * from "./DiscountBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports